import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FormattedMessage } from 'react-intl';
/**
 * Handles batch edit API response: either tracks async operation (operationId) via NotificationManager
 * or performs legacy sync handling (invalidateTable + toasts). Single source of truth for both
 * BatchEditDialog and fast actions.
 */
export function notifyBatchEditResponse(response, opts) {
    if (response && typeof response === 'object' && 'operationId' in response && response.operationId) {
        opts.trackOperation({
            operationId: String(response.operationId),
            processingToast: (_jsx(FormattedMessage, { id: "batchEditDialog.processingMessage", defaultMessage: "Processing update..." })),
            successToast: (status) => {
                const totalCount = status.totalCount ?? 0;
                const updated = status.processed?.updated ?? 0;
                const blockedInCall = status.processed?.blockedInCall ?? 0;
                const blockedFinalResponseCode = status.processed?.blockedFinalResponseCode ?? 0;
                const totalBlocked = status.processed?.blocked ?? 0;
                const noChanges = status.processed?.noChanges ?? 0;
                return (_jsxs(_Fragment, { children: [_jsx("strong", { children: _jsx(FormattedMessage, { id: "batchEditDialog.successMessage", defaultMessage: "Edit completed successfully!" }) }), _jsx("br", {}), _jsx(FormattedMessage, { id: "batchEditDialog.rowsProcessed", defaultMessage: "{processed} rows processed", values: { processed: totalCount } }), _jsx("br", {}), _jsx("br", {}), _jsx(FormattedMessage, { id: "batchEditDialog.updated", defaultMessage: "{updated} updated", values: { updated } }), _jsx("br", {}), _jsx(FormattedMessage, { id: "batchEditDialog.blocked", defaultMessage: "{blocked} blocked", values: { blocked: totalBlocked } }), blockedInCall > 0 && (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsx("span", { style: { marginLeft: 16 }, children: _jsx(FormattedMessage, { id: "batchEditDialog.blockedInCall", defaultMessage: "\u2022 {blockedInCall} in call", values: { blockedInCall } }) })] })), blockedFinalResponseCode > 0 && (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsx("span", { style: { marginLeft: 16 }, children: _jsx(FormattedMessage, { id: "batchEditDialog.blockedFinalResponseCode", defaultMessage: "\u2022 {blockedFinalResponseCode} final response code", values: { blockedFinalResponseCode } }) })] })), _jsx("br", {}), _jsx(FormattedMessage, { id: "batchEditDialog.noChanges", defaultMessage: "{noChanges} no changes", values: { noChanges } })] }));
            },
            onVerified: () => {
                opts.toast(_jsx(FormattedMessage, { id: "batchEditDialog.info", defaultMessage: "Operation is processing in the background" }), { type: 'info' });
                opts.onVerified?.();
            },
            isWarning: (status) => (status.processed?.blocked ?? 0) > 0,
        });
    }
    else {
        opts.invalidateTable();
        opts.onLegacySuccess?.(response);
        const res = response;
        if (opts.showInfoDialog && res?.rowCount != null && opts.selectedRows != null && opts.totalRows != null) {
            const blocked = res.rowCount;
            const all = opts.selectedRows.length || opts.totalRows;
            const changed = all - blocked;
            opts.showInfoDialog({
                title: (_jsx(FormattedMessage, { id: "batchEditDialog.warning", values: { blocked, all, changed }, defaultMessage: "warning {blocked}, {all}, {changed}" })),
            });
        }
        else {
            opts.toast(_jsx(FormattedMessage, { id: "batchEditDialog.successMessageSimple", defaultMessage: "Edit completed!" }), {
                type: 'success',
            });
        }
    }
}
//# sourceMappingURL=trackBatchEditOperation.js.map